import React, { ReactElement, useState } from 'react';

import {
  actions as SearchStateActions,
  CourseLibrarySearchStateType,
} from '@/modules/reducers/courseLibrary';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getQueryString, pushParamsToUrl } from '@/lib/util';
import { Header, Search, SearchIcon } from 'elmo-elements';
import { CourseLibraryDefaultQueryString } from '@/pages/CourseLibrary/CourseLibraryRoutes';

const CourseLibraryHeader = ({ title }: { title?: string }): ReactElement => {
  const location = useLocation();
  const history = useHistory();
  const currentQueryString = getQueryString(
    location.search,
    CourseLibraryDefaultQueryString,
  );
  const [searchKeyword, setSearchKeyword] = useState(currentQueryString.search);

  const dispatch = useDispatch();

  const searchState: CourseLibrarySearchStateType = useSelector(
    (state: { courseLibrary: CourseLibrarySearchStateType }) =>
      state.courseLibrary,
  );

  const handleOpenSearch = () => {
    dispatch({ type: SearchStateActions.openSearch.type });
  };

  const handleCloseSearch = () => {
    dispatch({ type: SearchStateActions.closeSearch.type });
  };

  const handleSearchChange = (searchValue: string) => {
    setSearchKeyword(searchValue);
    if (searchValue === '') pushParamsToUrl({ search: '', page: 1 }, history);
  };

  return (
    <Header
      title={title}
      isSearchOpen={searchState.isSearchOpen}
      buttons={[
        {
          id: 'btn-open-search',
          icon: <SearchIcon />,
          label: 'Open Search',
          onClick: handleOpenSearch,
          showBtnLabel: false,
          tooltip: 'Open Search',
        },
      ]}
    >
      <Search
        value={searchKeyword}
        isVisible={searchState.isSearchOpen}
        onClose={handleCloseSearch}
        onChange={handleSearchChange}
        onSubmit={() => {
          pushParamsToUrl({ search: searchKeyword, page: 1 }, history);
        }}
        isSubmitEnabledAlways={true}
      />
    </Header>
  );
};

export default CourseLibraryHeader;
